import React, { Component, Fragment } from 'react';
import { withRouteData, Switch, Route } from 'react-static';
import {
  SingleColumnLayout,
  SingleColumnLayoutContentWrapper,
  SingleColumnLayoutHeader,
  ListIncompleteMessageWrapper,
  ListIncompleteMessage
} from '@flow/components/ui';
import { IPage } from 'types/IPage';
import * as NavigationAction from '@flow/store/navigation/actions';
import { connect } from 'react-redux';
import SEOTags from '@flow/components/seo/SEOTags';
import { renderContent } from '@flow/scenes/default/ui';
import { isTagInArray } from '@flow/utils/helperUtils';
import { IArt } from 'types/IArt';
import { IArts } from 'types/IArts';
import SimplePage from '@flow/scenes/simple/SimplePage';
import { renderList } from '@flow/components/grid/grid';
import { ART_PROGRAM_COMPLETED, PROGRAM_PAGE_NAVIGATION_ENABLED } from '@flow/utils/constants';
import { ProgramNavigation } from '@flow/components/navigation/ProgramNavigation';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import {TagList} from "@flow/components/tags/tags";

const SpecialArtSectionWrapper = styled.div`
  background-color: black;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 10em;
  
  > div {
    margin-bottom: 0;
  }
`;

const H2 = styled.h2`
  font-family: Flow-Poster-Bold;
  text-transform: uppercase;
  color: white;
  font-size: 4em;
  margin-top: ${3/4}em;
  margin-bottom: ${3/4}em;
  padding: 0 ${3/4}em;
  
  @media (max-width: 1920px) {
    font-size: ${40 / (1920 * 0.01)}vw;
  }
  
  @media (max-width: 1100px) {
    font-size: 2.5em;
  }
  
`;

interface Props {
  appLanguage: IAppLanguage;
  arts: IArts;
  slugBases: any;
  page: IPage;
  _setLanguage: any;
  match: any;
  programPageNavigation: ProgramPageNavigation;
}

interface State {
  tags: string[];
}

class Arts extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      tags: []
    };
  }

  componentWillMount() {
    const {
      appLanguage,
      _setLanguage,
      page,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions});
  }

  componentWillReceiveProps({
      appLanguage,
      page,
    }: Props) {
    const {
      _setLanguage,
    } = this.props;

    const lang_versions = page && page.lang_versions;

    _setLanguage({ appLanguage, lang_versions });
  }

  render() {
    const {
      page,
      arts,
      match: {
        url
      },
      programPageNavigation,
      appLanguage
    } = this.props;

    const {
      content_group
    } = page;

    return (
      <Switch>
        <Route
          path={url}
          exact
          render={() => {
            let uniqueTags: {name: string}[] = [];
            arts.map((art: IArt) => {
              art.tags.map((tag: {name: string}) => {
                if (!isTagInArray(tag, uniqueTags)) {
                  uniqueTags.push({
                    name: tag.name
                  });
                }
              });
            });

            let visibleArts: IArt[] = this._getVisibleArts(
              arts,
              {tags: this.state.tags}
            );

            let festivalArt: IArt[] = visibleArts.filter((art: IArt) => {
              if (art.tags) {
                return !Boolean(art.tags.find((tag: {name: string}) => tag.name === (appLanguage.code === 'fi' ? 'FlowxOoppera' : 'FlowxOpera')));
              }
              return true;
            });

            let outsideFestivalArt: IArt[] = visibleArts.filter((art: IArt) => {
              if (art.tags) {
                return Boolean(art.tags.find((tag: {name: string}) => tag.name === (appLanguage.code === 'fi' ? 'FlowxOoppera' : 'FlowxOpera')));
              }
              return true;
            });

            return (
              <Fragment>
                <SEOTags page={page} />
                <SingleColumnLayout>
                  <SingleColumnLayoutHeader>
                    {PROGRAM_PAGE_NAVIGATION_ENABLED ? (
                      <ProgramNavigation programPageNavigation={programPageNavigation} />
                    ) : (
                      <h2>{page.title}</h2>
                    )}
                  </SingleColumnLayoutHeader>
                  {content_group &&
                    <SingleColumnLayoutContentWrapper>
                      { renderContent(content_group) }
                    </SingleColumnLayoutContentWrapper>
                  }
                  {uniqueTags && uniqueTags.length > 0 &&
                      <TagList tagsUpdated={(tags: string[]) => this.setState({tags})} tags={uniqueTags} />
                  }
                  {outsideFestivalArt.length > 0 &&
                  <SpecialArtSectionWrapper>
                      <H2><FormattedMessage id='arts.operaTitle'/></H2>
                    { renderList('art', outsideFestivalArt, 'black', 2) }
                  </SpecialArtSectionWrapper>
                  }

                  { Boolean(festivalArt && festivalArt.length > 0 && !ART_PROGRAM_COMPLETED) && (
                    <ListIncompleteMessageWrapper>
                      <ListIncompleteMessage><span className='dingbats'>⟚</span> <FormattedMessage id={'arts.flowArtsListInCompleted'}/> <span className='dingbats'>❂✧</span></ListIncompleteMessage>
                    </ListIncompleteMessageWrapper>
                  )}

                  {festivalArt.length > 0 &&
                  <Fragment>
                    {renderList('art', festivalArt)}
                  </Fragment>
                  }
                </SingleColumnLayout>
              </Fragment>
            );
          }}
        />
        <Route path={`${url}/:artId/`} component={SimplePage} />
      </Switch>
    );
  }

  private _getVisibleArts = (arts: IArts, filters: {tags: string[]}): IArts => {
    const filterKeys = Object.keys(filters);
    return arts.filter((art: IArt) => {
      return filterKeys.every(key => {
        if (!filters[key].length) {
          return arts;
        }

        if (art[key].length === 0)
          return false;

        return art[key].find(tag => filters[key].includes(tag.name));
      });
    });
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    _setLanguage: ({appLanguage, lang_versions }: ISetLanguage) => {
      dispatch(NavigationAction.setLanguage(appLanguage, lang_versions));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withRouteData(Arts));



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/arts/Arts.tsx